//import moment from 'moment-timezone';

const initialState = {
  // onGoingCalls: [{
  //   tag: 'outgoing',
  //   data: {
  //     id: 13123,
  //     to: '123131',
  //     from: '890',
  //     service_id: 15000,
  //     service_name: 'asdas das dasd asd askd askdjaskdaklsdadaskdaksdadas',
  //     schedule_date: '',
  //     isAnswered: true,
  //     startTime: 1517287806,
  //     application_name: 'asdas das dasd asd askd askdjaskdaklsdadaskdaksdadas'
  //   }
  // }],
  onGoingCalls: [],
  answeredCall: "",
  outgoing: null,
  incoming: null,
  terminatedCall: {
    data: {}
  },
}
export default function(state = initialState, action){
    switch(action.type){
        case "CALL_STARTED":
            return {
              ...state,
              onGoingCalls: [...state.onGoingCalls, action.payload],
            };
        case "CALL_ANSWERED":
          let onGoingCalls = getOnGoingCalls(state, action);
            return {
              ...state,
              // answeredCall: action.payload.data.id,
              onGoingCalls: onGoingCalls
            };
        case "CALL_ANSWERED_ID_UPDATE":
            return {
              ...state,
              answeredCall: action.payload
            }
        case "OUTGOING_TERMINATED":
        case "INCOMING_TERMINATED":
        case "INCOMING_MISSED":
            return {
              ...state,
              onGoingCalls: state.onGoingCalls.filter(item => (item.data.id !== action.payload.data.id)),
              terminatedCall: action.payload
            };
        default:
            return state;
    }
}

function getOnGoingCalls(state, action) {
  let isCallExists = false

  let onGoingCalls = [];
  state.onGoingCalls.forEach(item => {
    if(item.data.id === action.payload.data.id) {
      onGoingCalls.push({
        ...item,
        data: {
          ...item.data,
          isAnswered: true
        }
      });
      isCallExists = true;
    }
    else {
      onGoingCalls.push({ ...item });
    }
  });

  if(isCallExists) {
    return onGoingCalls;
  }
  else {
    let actionData = { ...action.payload, data: { ...action.payload.data, isAnswered: true } };
    return [ ...onGoingCalls, actionData ];
  }
}


// WEBPACK FOOTER //
// ./src/reducers/runtime.js